import {useDispatch} from 'react-redux';
import useIntersectionObserver from '@stencil/use-intersection-observer';
import {omnitureThunk} from '../omniture-analytics.thunk';
import {setVisibleComponents, setLoadedComponents} from '../omniture-utils';
import {omnitureConfig} from '..';

const useOmnitureImpressions = (
  componentName: string,
  pageName: string,
  pageInfo: object,
  setLoadedComponent?: boolean,
) => {
  const dispatch = useDispatch();

  const omniWatcherOption = {
    root: null,
    threshHold: 0.1,
  };

  const [omniWatcherRef] = useIntersectionObserver(
    omniWatcherOption,
    () => {
      dispatch(
        omnitureThunk(pageName, omnitureConfig.events.pageScroll, {
          page: {
            pageInfo,
          },
        }),
      );
      setVisibleComponents(componentName);
      if (setLoadedComponent) setLoadedComponents(componentName);
    },
    true,
  );

  return [omniWatcherRef];
};

export default useOmnitureImpressions;
